export const BEFORE_ROUTING_EVENT = 'single-spa:before-routing-event';
export const BEFORE_FIRST_MOUNT_EVENT = 'single-spa:before-first-mount';
